// extracted by mini-css-extract-plugin
export default {"activeLocatoin":"AllStores_activeLocatoin__-wcPS","activeImage":"AllStores_activeImage__UQyY4"};